import type { FieldValueSource } from './workflows';
import type { LogicalOperator } from 'vince-core/types/common';

export enum DataType {
    STRING = 'STRING',
    NUMBER = 'NUMBER',
    BOOLEAN = 'BOOLEAN'
}

export enum Comparison {
    equal = 'equal',
    notEqual = 'notEqual',
    lessThan = 'lessThan',
    lessThanInclusive = 'lessThanInclusive',
    greaterThan = 'greaterThan',
    greaterThanInclusive = 'greaterThanInclusive',
    isBlank = 'isBlank',
    isNotBlank = 'isNotBlank',
    stringContains = 'stringContains',
    stringNotContains = 'stringNotContains',
}

export interface FilterField {
    from: 'Row';
    fact: string;

    logicalType: LogicalOperator;
    clientKey: string;
    dataType: DataType;

    source: FieldValueSource;
    value: string | number;
    operator: Comparison;
    defaultValue?: string| number;
}

export interface GenericFilter {
    all?: (FilterField | GenericFilter) [];
    any?: (FilterField | GenericFilter) [];
}

export interface EnrichedGenericFilter {
    fields: FilterField[];
}
